export default __webpack_public_path__ + "static/glass-12-e348fd3d533690ebf7241a6b8e6dc7c2.jpg";